module.exports = require("./sd-Arab");